var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronRightEnd = function SvgChevronRightEnd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41438 7.46855C6.15562 7.1451 6.20806 6.67314 6.53151 6.41438C6.85495 6.15562 7.32692 6.20806 7.58568 6.53151L11.5857 11.5315C11.8048 11.8054 11.8048 12.1946 11.5857 12.4686L7.58568 17.4686C7.32692 17.792 6.85495 17.8444 6.53151 17.5857C6.20806 17.3269 6.15562 16.855 6.41438 16.5315L10.0396 12L6.41438 7.46855ZM12.4144 7.46855C12.1556 7.1451 12.2081 6.67314 12.5315 6.41438C12.855 6.15562 13.3269 6.20806 13.5857 6.53151L17.5857 11.5315C17.8048 11.8054 17.8048 12.1946 17.5857 12.4686L13.5857 17.4686C13.3269 17.792 12.855 17.8444 12.5315 17.5857C12.2081 17.3269 12.1556 16.855 12.4144 16.5315L16.0396 12L12.4144 7.46855Z",
    fill: "#18191B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRightEnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-right-end.63381bb7f507556c4a54c4d260f68bf6.svg";